import { render, staticRenderFns } from "./CandidateReport.vue?vue&type=template&id=98983de8&"
import script from "./CandidateReport.vue?vue&type=script&lang=js&"
export * from "./CandidateReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports